<template>
    <div class="flex-grid--reduced-bottom-margin">
        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
            <div class="flex-grid__g-3">
                <div class="u-margin-bottom-20 u-bold">
                    Category
                </div> 
                <div class="flex-grid__g-9 a-form-inputs--default">
                    <select name="category" id="category" v-model="category">
                        <option :value="null">All</option>
                        <option v-for="item in categoryList"
                                :value="item"
                                :selected="item == category ? 'true' : 'false' ">
                            {{ item }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="flex-grid__g-3">
                <div class="u-margin-bottom-20 u-bold">
                    Name
                </div> 
                <div class="flex-grid__g-9 a-form-inputs--default">
                    <input autocomplete="off" name="name" id="name" type="text" v-model="documentName">
                </div>
            </div>
            <div class="flex-grid__g-3">
                <div class="u-margin-bottom-20 u-bold">
                    Order By
                </div> 
                <div class="flex-grid__g-9 a-form-inputs--default">
                    <select name="orderBy" id="orderBy" v-model="orderBy">
                        <option value="ASC">Ascending</option>Document Type
                        <option value="DESC">Descending</option>
                    </select>
                </div>
            </div>
            <div class="flex-grid__g-3 u-align-self-flex-end u-r-align-self-flex-start">
                <button class="a-button a-button--small a-button--no-margin" @click="documentSearch">Search</button>
            </div>
        </div>
        <div class="a-loader--documents" v-if="loading"></div>
        <div class="flex-grid p-resources-and-tools__documents" v-if="!loading">
            <div class="p-resources-and-tools__document" v-for="document in documents">
                <div class="p-resources-and-tools__document-image">
                    <a :href="document['link']+'?access_token='+getToken" target="_blank">
                        <img :src="document['thumbnail_src']+'?access_token='+getToken" :alt="document['name']" style="width: 100%; height: auto">
                    </a>
                </div>
                <p>
                    <a :href="document['link']+'?access_token='+getToken" target="_blank">{{ document['name'] }}</a>
                    <span v-if="document['published_date']">Published at: {{ document['published_date'] }}</span>
                </p>
            </div>
            <p v-show="!documents.length">Documents will return shortly.</p>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'documents',
        data() {
            return {
                loading: true,
            }
        },
        computed: {
            ...mapGetters('user', [
                'getToken',
            ]),
            ...mapGetters({
                resources: 'resources/getResources',
                documents: 'resources/getDocuments',
            }),
            categoryList: {
                get() {
                    return this.resources.categoryList
                }
            },
            category: {
                get() {
                    return this.resources.category
                },
                set(value) {
                    if (value === 'All') {
                        value = null;
                    }
                    this.setTheCategory(value);
                }
            },
            documentName: {
                get() {
                    return this.resources.documentName
                },
                set(value) {
                    this.setTheDocumentName(value);
                }
            },
            orderBy: {
                get() {
                    return this.resources.orderBy
                },
                set(value) {
                    this.setTheOrderBy(value);
                }
            },
        },
        created() {
            this.documentSearch();
        },
        methods: {
            ...mapActions({
                getDocsFromServer: 'resources/getDocumentsFromServer',
                theDocumentSearch: 'resources/documentSearch',
                setTheCategory: 'resources/setCategory',
                setTheDocumentName: 'resources/setDocumentName',
                setTheOrderBy: 'resources/setOrderBy'
            }),
            documentSearch() {
                this.loading = true;

                this.theDocumentSearch().then(() => {
                    this.loading = false;
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Documents.vue?4250ac54